export const formatAddress = ({
  address1,
  address2,
  city,
  state,
  zipCode,
  isRemote,
}: {
  address1: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  isRemote?: boolean;
}) => {
  if (isRemote) {
    return <>Remote</>;
  }

  return (
    <>
      {address1}
      {address2 && (
        <>
          <br />
          {address2}
        </>
      )}
      <br />
      {city}, {state} {zipCode}
    </>
  );
};
